/* eslint-disable */
import request from "../api/Request";

export interface IUserLoginParams {
  emailOrPhoneNumber: string;
  password: string;
}

export interface IUserSignupParams {
  name: string;
  email: string;
  password: string;
}

export interface IUserGroupParams {
  name: string;
  intro: string;
}

export interface IEditUserGroupParams {
  userIds: number[];
  userGroupId: number;
}

export const userLogin = async (params: IUserLoginParams): Promise<any> =>
  request(`/auth/login`, params, "POST", true);

export const userSignup = async (params: IUserSignupParams): Promise<any> =>
  request(`/auth/signup`, params, "POST", true);

// // 获取当前用户
// export const getCurrentUser = async (): Promise<any> =>
//   request(`/api/v1/user/me`, {}, "GET", true);
// 获取当前用户
export const getCurrentUser = async (): Promise<any> =>
  request(`/user/me`, {}, "GET", true);

// 用户组创建
export const userGroupCreate = async (params: IUserGroupParams): Promise<any> =>
  request(`/user-group`, params, "POST", true);

// 用户组删除
export const userGroupDelete = async (groupId: number): Promise<any> =>
  request(`/user-group/${groupId}`, {}, "DELETE", true);

// 用户组信息编辑
export const userGroupEdit = async (
  params: IUserGroupParams,
  groupId: number
): Promise<any> => request(`/user-group/${groupId}`, params, "PATCH", true);

// 添加用户到用户组
export const addUserToGroup = async (
  params: IEditUserGroupParams
): Promise<any> => request(`/user-group/add-user-to-group`, params, "PATCH", true);

// 删除用户
export const removeUserFromGroup = async (
  params: IEditUserGroupParams
): Promise<any> =>
  request(`/user-group/remove-user-from-group`, params, "PATCH", true);

// 获取用户组下的用户列表
export const listUserFromGroup = async (userGroupId: string): Promise<any> =>
  request(`/user-group/users/${userGroupId}`, {}, "GET", true);

// 查询所有用户组
export const listGroup = async (): Promise<any> =>
  request(`/user-group/list-all`, {}, "GET", true);

// 获取公司下的用户列表
export const listUserFromCompany = async (companyId: string): Promise<any> =>
  request(`/company/user-usergroup/${companyId}`, {}, "GET", true);
